var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiamond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.74 8.16L17.59 3.65C17.2125 3.23731 16.6794 3.00158 16.12 3H7.88003C7.32069 3.00158 6.78758 3.23731 6.41003 3.65L2.26003 8.16C2.091 8.34595 1.99818 8.58872 2.00003 8.84V9.14C1.99957 9.37365 2.08095 9.60009 2.23003 9.78L11.23 20.64C11.4204 20.8685 11.7026 21.0005 12 21C12.2975 21.0005 12.5797 20.8685 12.77 20.64L21.77 9.78C21.9191 9.60009 22.0005 9.37365 22 9.14V8.84C22.0019 8.58872 21.9091 8.34595 21.74 8.16ZM11.18 17.47L4.53003 9.47C4.40024 9.41753 4.33756 9.26979 4.39003 9.14C4.44249 9.01021 4.59024 8.94753 4.72003 9H8.27003C8.72089 8.97794 9.13063 9.26066 9.27003 9.69L11.66 17.24C11.7235 17.3725 11.6676 17.5315 11.535 17.595C11.4025 17.6585 11.2435 17.6025 11.18 17.47ZM13.07 9H19.24C19.3388 8.9987 19.4276 8.93933 19.4665 8.8485C19.5055 8.75768 19.4872 8.65244 19.42 8.58L16.31 5.2C16.2626 5.14787 16.1955 5.11815 16.125 5.11815C16.0546 5.11815 15.9874 5.14787 15.94 5.2L12.88 8.58C12.8115 8.65377 12.794 8.76142 12.8355 8.85313C12.877 8.94485 12.9694 9.00273 13.07 9Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/diamond.4172e4ee5e26fc94908562161addee2f.svg";
export { ForwardRef as ReactComponent };